import { useState } from "react";
import { toast } from "sonner";
import { PencilSimple } from "@phosphor-icons/react";
import api, { formatApiError } from "@/lib/api";
import MovementDateField, { toLocalInput } from "@/components/MovementDateField";

// Inline editor for the date/time of an existing movement (Admin/Gestore, not for exits).
export default function MovementDateEditor({ movement, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  const start = () => { setValue(toLocalInput(new Date(movement.created_at))); setEditing(true); };
  const save = async () => {
    if (!value) { toast.error("Scegli una data"); return; }
    setSaving(true);
    try {
      await api.put(`/movements/${movement.id}`, { movement_date: new Date(value).toISOString() });
      toast.success(movement.movement_group_id ? "Data aggiornata per tutto il movimento" : "Data aggiornata");
      setEditing(false);
      await onSaved?.();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  if (!editing) {
    return (
      <button type="button" data-testid="mov-detail-edit-date" onClick={start} className="mt-1 inline-flex items-center gap-1 text-[11px] text-[#002FA7] hover:underline">
        <PencilSimple size={11} weight="bold" /> Modifica data e ora
      </button>
    );
  }
  return (
    <div className="mt-2 p-3 border border-[#002FA7]/30 bg-[#002FA7]/5 space-y-2" data-testid="mov-detail-date-editor">
      <MovementDateField value={value} onChange={setValue} showHint={false} testid="mov-detail-date" />
      {movement.ddt_number && <p className="text-xs text-neutral-600">Con numero DDT la data può cambiare solo all'interno dello stesso anno.</p>}
      <div className="flex justify-end gap-2">
        <button type="button" onClick={() => setEditing(false)} className="px-3 py-1.5 text-xs border border-neutral-300 hover:bg-neutral-100">Annulla</button>
        <button type="button" data-testid="mov-detail-date-save" disabled={saving} onClick={save} className="px-3 py-1.5 text-xs bg-[#002FA7] hover:bg-[#002480] text-white disabled:opacity-50">
          {saving ? "..." : "Salva data"}
        </button>
      </div>
    </div>
  );
}
